export enum UserRoleEnum {
  // システム管理者
  SYSTEM_MANAGEMENT = '01',
  // 全体管理者
  GLOBAL_MANAGEMENT = '02',
  // フォルダ管理者
  FOLDER_MANAGEMENT = '03',
  // 送信可能
  SENDABLE_USER = '04',
  //受領可能
  RECEIVABLE_USER = '05',
}
